import { gql } from "@apollo/client";

export const GET_CLIENTE_AUTORIZADOR = gql`
query clienteAutorizador($idCliente: String!) {
    clienteAutorizador(idCliente: $idCliente) {
        fechaAlta
        idusuario
        cod_cliente
    }
}`;